// 三高修复业务员子系统配置

import QRCode from "qrcode";

// 问卷页面基础地址（另一个项目）。
// 链接拼上 salesmanId 与 orgId 后生成完整链接 + 二维码。
// 部署环境变化时改这里即可。
export const SAN_GAO_QUESTIONNAIRE_BASE_URL =
    "https://chronicaweb.healthmore.net/#/disease-intro";

export function isTaikangOrganization(organization) {
    return !!organization && Number(organization.companyId) === 12;
}

// 只使用后端查询到的机构保司信息。机构未确认时不展示报销/补贴说明，
// 避免旧缓存、接口加载中或失败时把普通机构的说明展示给泰康客户。
export function canShowExamReimbursement(organization) {
    return !!organization &&
        Object.prototype.hasOwnProperty.call(organization, "companyId") &&
        !isTaikangOrganization(organization);
}

// 本地生成二维码 data URL（qrcode 库，无网络请求，秒出）
// 之前用境外三方 api.qrserver.com 生成，国内访问慢且不稳定，已废弃
export async function buildQrImageUrl(link, size = 320) {
    try {
        return await QRCode.toDataURL(link, {
            width: size,
            margin: 2,
            errorCorrectionLevel: "M",
        });
    } catch (e) {
        return "";
    }
}
